// Server measures and memberships are authoritative; stale refreshes are not current facts.
export function currentWorkspaceCoverage(read) {
  if (read.loading || read.error || !read.data) return {data:null,measures:null,members:[],diagnostics:null}
  return {data:read.data,measures:read.data.measures || null,
    members:(read.data.schoolTeamMembers || []).filter(member=>member?.id&&member?.name),
    diagnostics:read.data.schoolTeamCoverageDiagnostics || null}
}
